import React, { useContext, useEffect, useState } from 'react';
import '../../../../App.css';
import SpText from '../../../../components/atoms/SpText';
import { Grid } from '@material-ui/core';
import { withSnackbar } from '../../../../components/atoms/SpSnackBar';
import moment from 'moment';
import { getResourceFromServer } from '../../../../models/actions/Files';
import { UserSessionContext } from '../../../../App';
moment.locale('it');

const StationClosedReportDetailDialog = (props) => {
  const [fileURL, setFileURL] = useState(null);

  const { selectedReport, register, handleSubmit } = props;

  const { authData, setAuthData } = useContext(UserSessionContext);

  const fetchData = async () => {
    try {
      const resourceDetail = await getResourceFromServer({ file: selectedReport?.file }, authData.accessToken);
      if (resourceDetail) setFileURL(resourceDetail);
    } catch (error) {
      props.snackbarShowErrorMessage('Errore file!');
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const LabelValue = (props) => (
    <Grid
      item
      xs
      container
      direction="column"
      style={{ marginBottom: '2px' }}
    >
      <Grid
        item
        xs
      >
        <SpText variant="dialogReservationDetailTitle">{props.label + ':'}</SpText>
      </Grid>
      <Grid
        item
        xs
      >
        <SpText variant="text">{props.value}</SpText>
      </Grid>
    </Grid>
  );

  return (
    <Grid
      container
      direction="row"
    >
      <Grid
        item
        xs={5}
      >
        <img
          src={fileURL}
          style={{ width: '300px', height: '300px' }}
        />
      </Grid>
      <Grid
        item
        xs={7}
        container
        direction="column"
        spacing={2}
      >
        <LabelValue
          label={'Data di apertura della segnalazione'}
          value={moment(selectedReport?.creation_date).format('DD/MM/yyyy')}
        />
        <LabelValue
          label={'Ammontare addebito (€)'}
          value={selectedReport?.amount_to_pay ? selectedReport?.amount_to_pay : '0'}
        />
        <LabelValue
          label={`Parte danneggiata`}
          value={selectedReport?.bike_part}
        />
        <LabelValue
          label={`Dettaglio danno`}
          value={selectedReport?.bike_part_detail}
        />
        <LabelValue
          label={'Note'}
          value={selectedReport?.note ? selectedReport?.note : 'Nessuna nota'}
        />
      </Grid>
    </Grid>
  );
};

export default withSnackbar(StationClosedReportDetailDialog);
